<template>
  <div class="app-container contact-container">
    <!-- 复用头部组件 -->
    <!-- <Top></Top> -->

    <!-- 页面主标题 -->
    <section class="contact-header">
      <div class="container">
        <h2 class="contact-title">模型举报</h2>
        <!-- <p class="contact-desc">无论您是需要定制专属3D模型，还是发现违规模型需要举报，我们都会及时响应</p> -->
      </div>
    </section>

    <!-- 核心表单区 -->
    <section class="contact-form-section">
      <div class="container">
        <!-- 选项卡切换 -->
        <!-- <div class="form-tabs">
          <button class="form-tab-btn" :class="{ active: activeTab === 'custom' }" @click="switchTab('custom')">
            定制模型
          </button>
          <button class="form-tab-btn" :class="{ active: activeTab === 'report' }" @click="switchTab('report')">
            举报模型
          </button>
        </div> -->

        <!-- 定制模型表单 -->
        <div class="form-content" v-show="activeTab === 'custom'">
          <form ref="customForm" class="custom-model-form native-form" @submit.prevent="submitCustomForm">
            <!-- 联系人姓名 -->
            <div class="form-group">
              <label class="form-label" for="customName">联系人姓名 <span class="required">*</span></label>
              <input type="text" id="customName" class="form-control" v-model="customForm.name" placeholder="请输入您的姓名"
                maxlength="20" required>
              <div class="char-count">{{ customForm.name.length }}/20</div>
            </div>

            <!-- 联系电话 -->
            <div class="form-group">
              <label class="form-label" for="customPhone">联系电话 <span class="required">*</span></label>
              <input type="tel" id="customPhone" class="form-control" v-model="customForm.phone" placeholder="请输入您的手机号码"
                maxlength="11" pattern="^1[3-9]\d{9}$" required>
              <div class="char-count">{{ customForm.phone.length }}/11</div>
              <div class="error-tip" v-if="phoneError">{{ phoneError }}</div>
            </div>

            <!-- 电子邮箱 -->
            <div class="form-group">
              <label class="form-label" for="customEmail">电子邮箱 <span class="required">*</span></label>
              <input type="email" id="customEmail" class="form-control" v-model="customForm.email"
                placeholder="请输入您的电子邮箱" maxlength="50" required>
              <div class="char-count">{{ customForm.email.length }}/50</div>
              <div class="error-tip" v-if="emailError">{{ emailError }}</div>
            </div>

            <!-- 模型类型 -->
            <!-- <div class="form-group">
              <label class="form-label" for="customModelType">模型类型 <span class="required">*</span></label>
              <select 
                id="customModelType"
                class="form-control" 
                v-model="customForm.modelType" 
                required
              >
                <option value="">请选择需要定制的模型类型</option>
                <option value="industrial">工业建模</option>
                <option value="character">角色建模</option>
                <option value="scene">场景建模</option>
                <option value="architecture">建筑建模</option>
                <option value="mechanical">机械建模</option>
                <option value="game">游戏建模</option>
                <option value="film">影视建模</option>
                <option value="vrar">VR/AR建模</option>
                <option value="cartoon">卡通建模</option>
                <option value="other">其他类型</option>
              </select>
            </div> -->

            <!-- 定制需求描述 -->
            <div class="form-group">
              <label class="form-label" for="customDescription">定制需求描述 <span class="required">*</span></label>
              <textarea id="customDescription" class="form-control textarea" v-model="customForm.description" rows="6"
                placeholder="请详细描述您的模型定制需求，包括尺寸、风格、用途、交付时间等" maxlength="1000" required></textarea>
              <div class="char-count">{{ customForm.description.length }}/1000</div>
              <div class="error-tip" v-if="descError">{{ descError }}</div>
            </div>

            <!-- 附件参考（选填） -->
            <div class="form-group">
              <label class="form-label">附件参考（选填）</label>
              <div class="file-upload">
                <label class="upload-btn">
                  <span>点击上传参考文件</span>
                  <input type="file" multiple accept=".jpg,.png,.psd,.blend,.fbx,.obj,.zip,.rar"
                    @change="handleFileUpload('custom', $event)">
                </label>
                <div class="upload-tip">
                  可上传参考图片、设计稿等文件，支持jpg/png/psd/blend/fbx/obj/zip/rar格式，单文件不超过10MB
                </div>
                <!-- 文件列表 -->
                <div class="file-list" v-if="customForm.fileList.length">
                  <div class="file-item" v-for="(file, index) in customForm.fileList" :key="index">
                    <span class="file-name">{{ file.name }}</span>
                    <button type="button" class="file-remove" @click="removeFile('custom', index)">×</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 预算范围（选填） -->
            <div class="form-group">
              <label class="form-label" for="customBudget">预算范围（选填）</label>
              <input type="text" id="customBudget" class="form-control" v-model="customForm.budget"
                placeholder="请输入您的预算范围（元），例如：5000-10000" maxlength="50">
              <div class="char-count">{{ customForm.budget.length }}/50</div>
            </div>

            <!-- 期望交付时间（选填） -->
            <div class="form-group">
              <label class="form-label" for="customDeliveryTime">期望交付时间（选填）</label>
              <input type="date" id="customDeliveryTime" class="form-control" v-model="customForm.deliveryTime">
            </div>

            <!-- 是否保密 -->
            <div class="form-group">
              <label class="form-label">是否保密 <span class="required">*</span></label>
              <div class="radio-group">
                <label class="radio-item">
                  <input type="radio" name="isSecret" v-model="customForm.isSecret" value="是" required>
                  <span class="radio-label">是（签订保密协议）</span>
                </label>
                <label class="radio-item">
                  <input type="radio" name="isSecret" v-model="customForm.isSecret" value="否" required>
                  <span class="radio-label">否</span>
                </label>
              </div>
            </div>

            <!-- 提交按钮 -->
            <div class="form-actions">
              <button type="submit" class="btn submit-btn" :disabled="customFormLoading">
                <span v-if="customFormLoading">提交中...</span>
                <span v-else>提交定制需求</span>
              </button>
              <button type="button" class="btn reset-btn" @click="resetCustomForm">
                重置
              </button>
            </div>
          </form>
        </div>

        <!-- 举报模型表单 -->
        <div class="form-content" v-show="activeTab === 'report'">
          <form ref="reportForm" class="report-model-form native-form" @submit.prevent="submitReportForm">
            <!-- 举报人姓名 -->
            <div class="form-group">
              <label class="form-label" for="reportName">举报人姓名 <span class="required">*</span></label>
              <input type="text" id="reportName" class="form-control" v-model="reportForm.reporterName"
                placeholder="请输入您的姓名（仅用于联系核实）" maxlength="20" required>
              <div class="char-count">{{ reportForm.reporterName.length }}/20</div>
            </div>

            <!-- 联系电话 -->
            <div class="form-group">
              <label class="form-label" for="reportPhone">联系电话 <span class="required">*</span></label>
              <input type="tel" id="reportPhone" class="form-control" v-model="reportForm.reporterPhone"
                placeholder="请输入您的手机号码（仅用于联系核实）" maxlength="11" pattern="^1[3-9]\d{9}$" required>
              <div class="char-count">{{ reportForm.reporterPhone.length }}/11</div>
              <div class="error-tip" v-if="reportPhoneError">{{ reportPhoneError }}</div>
            </div>

            <!-- 举报模型链接 -->
            <div class="form-group">
              <label class="form-label" for="reportModelUrl">举报模型链接 <span class="required">*</span></label>
              <input type="url" id="reportModelUrl" class="form-control" v-model="reportForm.modelUrl"
                placeholder="请粘贴需要举报的模型详情页链接" maxlength="200" required>
              <div class="char-count">{{ reportForm.modelUrl.length }}/200</div>
              <div class="error-tip" v-if="urlError">{{ urlError }}</div>
            </div>

            <!-- 举报类型 -->
            <div class="form-group">
              <label class="form-label">举报类型 <span class="required">*</span></label>
              <div class="checkbox-group">
                <label class="checkbox-item" v-for="type in reportTypes" :key="type.value">
                  <input type="checkbox" v-model="reportForm.reportType" :value="type.label"
                    @change="handleOtherCheck(type.label)">
                  <span class="checkbox-label">{{ type.label }}</span>
                </label>
              </div>
              <div class="error-tip" v-if="reportTypeError">{{ reportTypeError }}</div>
            </div>

            <!-- 其他问题补充说明 -->
            <!-- <div class="form-group" v-if="reportForm.reportType.includes('其他问题')">
              <label class="form-label" for="reportOtherDesc">补充说明 <span class="required">*</span></label>
              <textarea 
                id="reportOtherDesc"
                class="form-control textarea" 
                v-model="reportForm.otherDescription"
                rows="4"
                placeholder="请详细描述您举报的其他问题"
                maxlength="500"
                required
              ></textarea>
              <div class="char-count">{{ reportForm.otherDescription.length }}/500</div>
              <div class="error-tip" v-if="otherDescError">{{ otherDescError }}</div>
            </div> -->

            <!-- 举报描述 -->
            <div class="form-group">
              <label class="form-label" for="reportDescription">举报描述 <span class="required">*</span></label>
              <textarea id="reportDescription" class="form-control textarea" v-model="reportForm.description" rows="6"
                placeholder="请详细描述举报原因、具体问题等信息，以便我们核实处理" maxlength="1000" required></textarea>
              <div class="char-count">{{ reportForm.description.length }}/1000</div>
              <div class="error-tip" v-if="reportDescError">{{ reportDescError }}</div>
            </div>

            <!-- 举证材料（选填） -->
            <div class="form-group">
              <label class="form-label">举证材料（选填）</label>
              <div class="file-upload">
                <label class="upload-btn">
                  <span>点击上传举证材料</span>
                  <input type="file" multiple accept=".jpg,.png,.gif,.mp4,.avi,.zip,.rar"
                    @change="handleFileUpload('report', $event)">
                </label>
                <div class="upload-tip">
                  可上传截图、视频等举证材料，支持jpg/png/gif/mp4/avi/zip/rar格式，单文件不超过20MB
                </div>
                <!-- 文件列表 -->
                <div class="file-list" v-if="reportForm.fileList.length">
                  <div class="file-item" v-for="(file, index) in reportForm.fileList" :key="index">
                    <span class="file-name">{{ file.name }}</span>
                    <button type="button" class="file-remove" @click="removeFile('report', index)">×</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 是否匿名举报 -->
            <div class="form-group">
              <label class="form-label">是否匿名举报</label>
              <div class="radio-group">
                <label class="radio-item">
                  <input type="radio" name="isAnonymous" v-model="reportForm.isAnonymous" value="是">
                  <span class="radio-label">是（我们将对您的信息严格保密）</span>
                </label>
                <label class="radio-item">
                  <input type="radio" name="isAnonymous" v-model="reportForm.isAnonymous" value="否">
                  <span class="radio-label">否（方便我们联系核实）</span>
                </label>
              </div>
            </div>

            <!-- 提交按钮 -->
            <div class="form-actions">
              <button type="submit" class="btn submit-btn" :disabled="reportFormLoading">
                <span v-if="reportFormLoading">提交中...</span>
                <span v-else>提交举报</span>
              </button>
              <button type="button" class="btn reset-btn" @click="resetReportForm">
                重置
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>

    <!-- 联系方式展示区 -->
    <section class="contact-info-section">
      <div class="container">
        <h2 class="section-title">联系方式</h2>
        <div class="contact-info-grid">
          <div class="contact-info-card">
            <div class="info-icon">📞</div>
            <h3 class="info-title">客服热线</h3>
            <p class="info-content">130-5185-0850</p>
            <p class="info-desc">工作日 9:00-18:00</p>
          </div>

          <div class="contact-info-card">
            <div class="info-icon">✉️</div>
            <h3 class="info-title">官方邮箱</h3>
            <p class="info-content">zhibuyunshang@swocs.com.cn</p>
            <p class="info-desc">工作日 24 小时内回复</p>
          </div>

          <!-- <div class="contact-info-card">
            <div class="info-icon">💬</div>
            <h3 class="info-title">在线客服</h3>
            <p class="info-content">点击右下角悬浮窗</p>
            <p class="info-desc">工作日 9:00-22:00</p>
          </div>

          <div class="contact-info-card">
            <div class="info-icon">📍</div>
            <h3 class="info-title">公司地址</h3>
            <p class="info-content">北京市朝阳区科技园区88号</p>
            <p class="info-desc">模型大厦15层</p>
          </div> -->
        </div>
      </div>
    </section>

    <!-- 复用版权组件 -->
    <!-- <Bottom></Bottom> -->

    <!-- 消息提示 -->
    <div class="message-toast" v-if="showMessage">
      <div :class="['message-content', messageType]">
        {{ messageText }}
      </div>
    </div>
  </div>
</template>

<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
  name: 'ContactUs',
  components: {
    Top,
    Bottom
  },
  data() {
    return {
      // 选项卡状态
      activeTab: 'report',

      // 定制模型表单数据
      customForm: {
        name: '',
        phone: '',
        email: '',
        modelType: '',
        description: '',
        fileList: [],
        budget: '',
        deliveryTime: '',
        isSecret: '否'
      },

      // 举报模型表单数据
      reportForm: {
        reporterName: '',
        reporterPhone: '',
        modelUrl: '',
        reportType: [],
        otherDescription: '',
        description: '',
        fileList: [],
        isAnonymous: '否'
      },

      // 加载状态
      customFormLoading: false,
      reportFormLoading: false,

      // 举报类型列表
      reportTypes: [
        { label: '侵犯版权/抄袭', value: 'copyright' },
        { label: '色情/低俗内容', value: 'porn' },
        { label: '暴力/恐怖内容', value: 'violence' },
        { label: '违法违规内容', value: 'illegal' },
        { label: '虚假宣传', value: 'false_ad' },
        { label: '恶意定价/欺诈', value: 'fraud' },
        { label: '模型质量问题', value: 'quality' },
        { label: '其他问题', value: 'other' }
      ],

      // 错误提示
      phoneError: '',
      emailError: '',
      descError: '',
      reportPhoneError: '',
      urlError: '',
      reportTypeError: '',
      otherDescError: '',
      reportDescError: '',

      // 消息提示
      showMessage: false,
      messageText: '',
      messageType: 'success' // success/error
    };
  },
  methods: {
    // 切换选项卡
    switchTab(tab) {
      this.activeTab = tab;
      // 清空错误提示
      this.clearAllErrors();
    },

    // 清空所有错误提示
    clearAllErrors() {
      this.phoneError = '';
      this.emailError = '';
      this.descError = '';
      this.reportPhoneError = '';
      this.urlError = '';
      this.reportTypeError = '';
      this.otherDescError = '';
      this.reportDescError = '';
    },

    // 处理其他选项勾选
    handleOtherCheck(label) {
      if (label === '其他问题' && !this.reportForm.reportType.includes('其他问题')) {
        this.reportForm.otherDescription = '';
      }
    },

    // 文件上传处理
    async handleFileUpload(type, event) {
      const files = Array.from(event.target.files);
      const maxSize = type === 'custom' ? 10 * 1024 * 1024 : 20 * 1024 * 1024; // 10MB/20MB

      // 遍历选中的文件
      for (const file of files) {
        // 1. 大小校验
        if (file.size > maxSize) {
          this.showToast(`文件 ${file.name} 大小不能超过${type === 'custom' ? '10' : '20'}MB!`, 'error');
          continue;
        }

        try {
          // 2. 构建 FormData（文件上传必须用这个格式）
          const formData = new FormData();
          formData.append('file', file); // 注意后端接收参数名需和这里一致

          // 3. 根据类型调用对应的封装接口
          let uploadRes;
          if (type === 'custom') {
            uploadRes = await this.$apiFun.postUploadReference(formData);
          } else {
            uploadRes = await this.$apiFun.postUploadProof(formData);
          }

          // 4. 上传成功：存储接口返回的文件信息（而非本地文件）
          if (uploadRes && uploadRes.status === 200) { // 假设接口返回有 code 字段
            const fileInfo = {
              name: file.name,
              url: uploadRes.obj.fileUrl, // 接口返回的文件地址，根据实际字段调整
              size: file.size,
              fileId: uploadRes.obj.fileId // 如有文件ID也建议存储
            };

            // 存入对应表单的文件列表
            type === 'custom'
              ? this.customForm.fileList.push(fileInfo)
              : this.reportForm.fileList.push(fileInfo);

            this.showToast(`文件 ${file.name} 上传成功!`, 'success');
          } else {
            this.showToast(`文件 ${file.name} 上传失败: ${uploadRes.msg || '接口返回异常'}`, 'error');
          }
        } catch (error) {
          // 5. 捕获网络/接口异常
          this.showToast(`文件 ${file.name} 上传失败: ${error.message || '网络错误'}`, 'error');
          console.error(`上传文件 ${file.name} 出错:`, error);
        }
      }

      // 清空input值，允许重复上传同一文件
      event.target.value = '';
    },

    // 移除文件
    removeFile(type, index) {
      if (type === 'custom') {
        this.customForm.fileList.splice(index, 1);
      } else {
        this.reportForm.fileList.splice(index, 1);
      }
    },

    // 验证定制模型表单
    validateCustomForm() {
      let isValid = true;
      this.clearAllErrors();

      // 验证手机号
      if (!this.customForm.phone) {
        this.phoneError = '请输入手机号码';
        isValid = false;
      } else if (!/^1[3-9]\d{9}$/.test(this.customForm.phone)) {
        this.phoneError = '请输入正确的手机号码';
        isValid = false;
      }

      // 验证邮箱
      if (!this.customForm.email) {
        this.emailError = '请输入电子邮箱';
        isValid = false;
      } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.customForm.email)) {
        this.emailError = '请输入正确的电子邮箱';
        isValid = false;
      }

      // 验证需求描述
      if (!this.customForm.description) {
        this.descError = '请输入定制需求描述';
        isValid = false;
      } else if (this.customForm.description.length < 10) {
        this.descError = '需求描述至少10个字符';
        isValid = false;
      }

      return isValid;
    },

    // 验证举报模型表单
    validateReportForm() {
      let isValid = true;
      this.clearAllErrors();

      // 验证手机号
      if (!this.reportForm.reporterPhone) {
        this.reportPhoneError = '请输入手机号码';
        isValid = false;
      } else if (!/^1[3-9]\d{9}$/.test(this.reportForm.reporterPhone)) {
        this.reportPhoneError = '请输入正确的手机号码';
        isValid = false;
      }

      // 修复：优化URL验证 - 支持http/https开头，兼容更多合法URL格式
      if (!this.reportForm.modelUrl) {
        this.urlError = '请输入举报模型链接';
        isValid = false;
      } else {
        // 全面兼容的URL正则：支持localhost、IP、域名、端口、路径、查询参数、哈希锚点
        const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:localhost|(?:[0-9]{1,3}\.){3}[0-9]{1,3}|(?:[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]\.)+[a-zA-Z]{2,})(?::\d{1,5})?(?:\/[^\s]*)*(?:\?[^\s]*)?(?:#[^\s]*)?$/;

        // 先去除首尾空格再验证
        const modelUrl = this.reportForm.modelUrl.trim();

        if (modelUrl === '') {
          this.urlError = '模型链接不能为空';
          isValid = false;
        } else if (!urlRegex.test(modelUrl)) {
          this.urlError = '请输入有效的URL链接（示例：http://localhost:8081/#/detail?id=xxx 或 https://tools.swocs.com.cn/model/1）';
          isValid = false;
        } else {
          // 验证通过，清空错误提示
          this.urlError = '';
        }
      }

      // 验证举报类型
      if (!this.reportForm.reportType || this.reportForm.reportType.length === 0) {
        this.reportTypeError = '请选择至少一个举报类型';
        isValid = false;
      }

      // 验证举报描述
      if (!this.reportForm.description) {
        this.reportDescError = '请输入举报描述';
        isValid = false;
      } else if (this.reportForm.description.length < 20) {
        this.reportDescError = '举报描述至少20个字符';
        isValid = false;
      }

      return isValid;
    },

    // 提交定制模型表单
    async submitCustomForm() {
      if (!this.validateCustomForm()) {
        return;
      }

      this.customFormLoading = true;

      try {
        // 组装接口需要的参数格式
        const requestData = {
          userName: this.customForm.name,
          contact: this.customForm.phone,
          email: this.customForm.email,
          fileName: this.customForm.fileList.map(f => f.name),
          fileUrl: this.customForm.fileList.map(f => f.url),
          budget: this.customForm.budget,
          delivery: this.customForm.deliveryTime,
          notes: this.customForm.description,
          whetherAnonymous: this.customForm.isSecret === '是' ? true : false
        };

        // 调用后端接口
        const res = await this.$apiFun.postCustomize(requestData);

        if (res.status === 200) {
          this.showToast('定制需求提交成功！我们将在1-2个工作日内与您联系', 'success');
          this.resetCustomForm();
        } else {
          this.showToast(`提交失败：${res.msg || '未知错误'}`, 'error');
        }
      } catch (error) {
        console.error('提交定制需求出错：', error);
        this.showToast('网络异常，提交失败', 'error');
      } finally {
        this.customFormLoading = false;
      }
    },

    // 重置定制模型表单
    resetCustomForm() {
      this.customForm = {
        name: '',
        phone: '',
        email: '',
        modelType: '',
        description: '',
        fileList: [],
        budget: '',
        deliveryTime: '',
        isSecret: '否'
      };
      this.clearAllErrors();
    },

    // 提交举报模型表单
    async submitReportForm() {
      if (!this.validateReportForm()) {
        return;
      }

      this.reportFormLoading = true;

      try {
        // 组装接口需要的参数格式
        const requestData = {
          userName: this.reportForm.reporterName,
          contact: this.reportForm.reporterPhone,
          link: this.reportForm.modelUrl,
          type: this.reportForm.reportType,
          fileName: this.reportForm.fileList.map(f => f.name),
          fileUrl: this.reportForm.fileList.map(f => f.url),
          notes: this.reportForm.description,
          whetherAnonymous: this.reportForm.isAnonymous === '是' ? true : false
        };

        // 调用后端接口
        const res = await this.$apiFun.postAccusation(requestData);

        if (res.status === 200) {
          this.showToast('举报提交成功！我们将在24小时内核实处理', 'success');
          this.resetReportForm();
        } else {
          this.showToast(`提交失败：${res.msg || '未知错误'}`, 'error');
        }
      } catch (error) {
        console.error('提交举报出错：', error);
        this.showToast('网络异常，提交失败', 'error');
      } finally {
        this.reportFormLoading = false;
      }
    },

    // 重置举报模型表单
    resetReportForm() {
      this.reportForm = {
        reporterName: '',
        reporterPhone: '',
        modelUrl: '',
        reportType: [],
        otherDescription: '',
        description: '',
        fileList: [],
        isAnonymous: '否'
      };
      this.clearAllErrors();
    },

    // 显示提示消息
    showToast(message, type = 'success') {
      this.messageText = message;
      this.messageType = type;
      this.showMessage = true;

      setTimeout(() => {
        this.showMessage = false;
      }, 3000);
    }
  }
};
</script>

<style lang="less" scoped>
// 继承全局主题色
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@accent: #7c3aed;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);
// 暗色输入框配色
@dark-input-bg: #1a1d29;
@dark-input-border: #2d3748;
@dark-input-hover-border: #4a5568;
@dark-input-focus-border: @primary;
@error-color: #ef4444;
@success-color: #10b981;

.contact-container {
  min-height: 100vh;
  background-color: @base-deep;
  color: @text-primary;
  padding-bottom: 40px;
}

// 页面头部
.contact-header {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  .contact-title {
    font-size: 1.8rem;
    padding: 0 40px;
    color: @primary-light;
    margin-bottom: 15px;
    text-shadow: 0 0 10px rgba(14, 165, 233, 0.2);
  }

  .contact-desc {
    font-size: 1.1rem;
    color: @text-secondary;
    max-width: 800px;
    margin: 0 auto;
  }
}

// 表单区域
.contact-form-section {
  padding: 20px 0 60px;

  .container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;
  }

  // 选项卡样式
  .form-tabs {
    display: flex;
    margin-bottom: 30px;
    border-bottom: 2px solid @border-color;

    .form-tab-btn {
      padding: 12px 30px;
      background: transparent;
      border: none;
      color: @text-secondary;
      font-size: 1.2rem;
      cursor: pointer;
      transition: all 0.3s;
      position: relative;

      &.active {
        color: @primary-light;

        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: @primary;
        }
      }

      &:hover:not(.active) {
        color: @primary;
      }
    }
  }

  // 表单内容
  .form-content {
    background-color: @base-darker;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    // 原生表单样式
    .native-form {
      width: 100%;

      // 表单组
      .form-group {
        margin-bottom: 25px;

        // 表单标签
        .form-label {
          display: block;
          margin-bottom: 8px;
          color: @text-primary;
          font-weight: 500;
          font-size: 14px;

          .required {
            color: @error-color;
            margin-left: 4px;
          }
        }

        // 表单控件
        .form-control {
          width: 100%;
          padding: 12px 15px;
          background-color: @dark-input-bg;
          border: 1px solid @dark-input-border;
          border-radius: 4px;
          color: @text-primary;
          font-size: 14px;
          box-sizing: border-box;
          transition: all 0.3s;

          &::placeholder {
            color: @text-secondary;
            opacity: 0.8;
          }

          &:hover {
            border-color: @dark-input-hover-border;
          }

          &:focus {
            outline: none;
            border-color: @dark-input-focus-border;
            box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.1);
          }

          &:invalid:not(:focus):not(:placeholder-shown) {
            border-color: @error-color;
          }
        }

        // 多行文本框
        .textarea {
          resize: vertical;
          min-height: 120px;
          line-height: 1.5;
        }

        // 字符计数
        .char-count {
          margin-top: 5px;
          font-size: 12px;
          color: @text-secondary;
          text-align: right;
        }

        // 错误提示
        .error-tip {
          margin-top: 5px;
          font-size: 12px;
          color: @error-color;
        }

        // 单选框组
        .radio-group {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;

          .radio-item {
            display: flex;
            align-items: center;
            cursor: pointer;

            input[type="radio"] {
              appearance: none;
              width: 18px;
              height: 18px;
              border: 2px solid @dark-input-border;
              border-radius: 10%;
              margin-right: 8px;
              position: relative;
              transition: all 0.3s;

              &:checked {
                border-color: @primary;

                &::after {
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 8px;
                  height: 8px;
                  border-radius: 10%;
                  background-color: @primary;
                }
              }

              &:hover {
                border-color: @dark-input-hover-border;
              }
            }

            .radio-label {
              color: @text-secondary;
              transition: color 0.3s;

              &:hover {
                color: @primary-light;
              }
            }
          }
        }

        // 复选框组
        .checkbox-group {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          margin-bottom: 10px;

          .checkbox-item {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-bottom: 10px;

            input[type="checkbox"] {
              appearance: none;
              width: 18px;
              height: 18px;
              border: 2px solid @dark-input-border;
              border-radius: 3px;
              margin-right: 8px;
              position: relative;
              transition: all 0.3s;

              &:checked {
                border-color: @primary;
                background-color: @primary;

                &::after {
                  content: '✓';
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  color: white;
                  font-size: 12px;
                  font-weight: bold;
                }
              }

              &:hover {
                border-color: @dark-input-hover-border;
              }
            }

            .checkbox-label {
              color: @text-secondary;
              transition: color 0.3s;

              &:hover {
                color: @primary-light;
              }
            }
          }
        }

        // 文件上传
        .file-upload {
          .upload-btn {
            display: inline-block;
            padding: 8px 16px;
            background-color: @primary;
            color: white;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            margin-bottom: 10px;
            transition: background-color 0.3s;

            &:hover {
              background-color: @primary-light;
            }

            input[type="file"] {
              display: none;
            }
          }

          .upload-tip {
            font-size: 12px;
            color: @text-secondary;
            margin-bottom: 10px;
          }

          .file-list {
            margin-top: 15px;

            .file-item {
              display: flex;
              align-items: center;
              padding: 8px 10px;
              background-color: @dark-input-bg;
              border-radius: 4px;
              margin-bottom: 8px;

              .file-name {
                flex: 1;
                color: @text-primary;
                font-size: 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .file-remove {
                background: transparent;
                border: none;
                color: @text-secondary;
                font-size: 16px;
                cursor: pointer;
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                transition: all 0.3s;

                &:hover {
                  color: @error-color;
                  background-color: rgba(239, 68, 68, 0.1);
                }
              }
            }
          }
        }
      }

      // 表单按钮组
      .form-actions {
        display: flex;
        gap: 15px;
        margin-top: 30px;

        .btn {
          padding: 12px 30px;
          border-radius: 4px;
          border: none;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;

          &:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }
        }

        .submit-btn {
          background-color: @primary;
          color: white;

          &:hover:not(:disabled) {
            background-color: @primary-light;
          }
        }

        .reset-btn {
          background-color: transparent;
          border: 1px solid @text-secondary;
          color: @text-secondary;

          &:hover {
            border-color: @primary;
            color: @primary-light;
          }
        }
      }
    }
  }
}

// 联系方式区域
.contact-info-section {
  padding: 40px 0;
  background-color: @base-darker;
  margin: 20px 0 40px;
  border-radius: 8px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section-title {
    font-size: 1.8rem;
    color: @primary-light;
    margin-bottom: 30px;
    padding-bottom: 15px;
    border-bottom: 1px solid @border-color;
    display: inline-block;
  }

  .contact-info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 30px;

    .contact-info-card {
      text-align: center;
      padding: 30px 20px;
      background-color: @base-deep;
      border-radius: 8px;
      border: 1px solid @border-color;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(14, 165, 233, 0.1);
        border-color: rgba(14, 165, 233, 0.2);
      }

      .info-icon {
        font-size: 2.5rem;
        margin-bottom: 15px;
      }

      .info-title {
        font-size: 1.2rem;
        color: @text-primary;
        margin-bottom: 10px;
      }

      .info-content {
        color: @primary-light;
        font-weight: 500;
        margin-bottom: 5px;
      }

      .info-desc {
        color: @text-secondary;
        font-size: 0.9rem;
      }
    }
  }
}

// 消息提示
.message-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  .message-content {
    padding: 12px 24px;
    border-radius: 4px;
    color: white;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    &.success {
      background-color: @success-color;
    }

    &.error {
      background-color: @error-color;
    }
  }
}

// 响应式适配
@media (max-width: 768px) {
  .contact-header {
    .contact-title {
      font-size: 2rem;
    }

    .contact-desc {
      font-size: 1rem;
      padding: 0 20px;
    }
  }

  .contact-form-section {
    .form-tabs {
      .form-tab-btn {
        padding: 10px 20px;
        font-size: 1rem;
      }
    }

    .form-content {
      padding: 20px;

      .native-form {
        .form-group {
          margin-bottom: 20px;

          .form-label {
            font-size: 0.9rem;
          }

          .radio-group,
          .checkbox-group {
            flex-direction: column;
            gap: 10px;
          }
        }

        .form-actions {
          flex-direction: column;

          .btn {
            width: 100%;
          }
        }
      }
    }
  }

  .contact-info-section {
    .contact-info-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
}
</style>